import React from 'react';
import { Box, Tooltip } from '@mui/material';
import i18n from '../../i18n';
import SmartAnalysisButton from '../common/smart-analysis-button.component';
import { DataExportIconButton } from '../../component/button/data-export-icon-button.component';

/**
 * 风控订单操作栏组件的属性
 */
interface RiskOrderActionBarProps {
    /**
     * 导出执行逻辑（可异步，如云端列表需分页拉全量再生成文件）
     * 与 {@link DataExportIconButton} 的 `onExport` 行为一致
     */
    onExport: () => void | Promise<void>;
    /** 导出按钮禁用，例如列表加载中 */
    exportDisabled?: boolean;
    /**
     * 同步预检：返回 false 时不执行 `onExport`、不进入 loading 态
     * （例如当前条件下总条数为 0）
     */
    exportPreCheck?: () => boolean;
    /** AI 智能分析按钮点击回调 */
    onAIAnalysisClick?: () => void;
}

/**
 * 风控订单操作栏组件
 * 包含下载按钮和数据智能分析按钮。
 * 智能分析授权（AU1030）在列表状态 `openAiAnalysisDialog` 中校验，与菜品分析页一致。
 */
const RiskOrderActionBar: React.FC<RiskOrderActionBarProps> = ({
    onExport,
    exportDisabled = false,
    exportPreCheck,
    onAIAnalysisClick
}) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
            <DataExportIconButton
                title={i18n.t('tunnel_management_page_export')}
                disabled={exportDisabled}
                preCheck={exportPreCheck}
                onExport={onExport}
            />
            {/* AI数据智能分析按钮：与设计稿「数据智能分析按钮」一致，渐变 + 浅色字 + 投影 */}
            <Tooltip title={i18n.t('intelligent_risk_control_page_text_data_intelligence_analysis')} placement='top' >
                <SmartAnalysisButton
                    onClick={onAIAnalysisClick}
                />
            </Tooltip>
        </Box>
    );
};

export default RiskOrderActionBar;
